/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/channels",
    },
    (router) => {
      router.push({
        id: "@api-legacy/channel@search",
        path: "",
      });

      router.group(
        {
          path: "/:channelId",
        },
        (router) => {
          router.push({
            id: "@api-legacy/channel@view",
            path: "",
          });

          router.push({
            id: "@api-legacy/channel@update",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api-legacy/channel@interop-inventory",
                path: "/interop-inventory",
              });
            },
          );
        },
      );

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api-legacy/channel@configuration",
            path: "/configuration",
          });
        },
      );
    },
  );
}
